import { IDeviceSensor } from 'app/shared/model/device-sensor.model';
import { AlertOperator } from 'app/shared/model/enumerations/alert-operator.model';
import { AlertType } from 'app/shared/model/enumerations/alert-type.model';
import { ISensor } from 'app/shared/model/sensor.model';
import { AlertCluster } from './enumerations/alert-cluster.model';

export const TPMS_GROUP_TYPE_PRESSURE = 'PRESSURE' as const;
export const TPMS_GROUP_TYPE_TEMPERATURE = 'TEMPERATURE' as const;

export type TpmsGroupType = typeof TPMS_GROUP_TYPE_PRESSURE | typeof TPMS_GROUP_TYPE_TEMPERATURE;

export interface IAlert {
  id?: number;
  name?: string | null;
  alertType?: AlertType | null;
  alertOperator?: AlertOperator | null;
  value?: number | null;
  valueInRangeMin?: number | null;
  valueInRangeMax?: number | null;
  deviceSensor?: IDeviceSensor | null;
  sensor?: ISensor | null;
  alertCluster?: AlertCluster | null;
  truckGroupIds?: number[] | null;
  tpmsGroupType?: TpmsGroupType | null;
}

export const defaultValue: Readonly<IAlert> = {};
